var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "modal-close-button",
    attrs: {
      "type": "button",
      "aria-label": _vm.ariaLabel
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "close",
      "size": 22
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }